import { BlogCategory } from '@shared/models/blog-category.model';
import { BlogService, TrackingService } from '@core/services';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from '@env/environment';
import { GhGlobal } from '@shared/helpers/global-functions';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

const HOME_MENU: BlogCategory = {
  id: 0,
  position: 0,
  description: '',
  name: 'Blog',
  slug: '',
  color: '#ff5a5a',
  marker: `${environment.cdnPath}/svgs/1613408570166%40peep_32x32.svg`,
  active: '1',
  types: ['top-bar']
};

@Component({
    selector: 'gh-category-menu-section',
    templateUrl: 'category-menu-section.component.html',
    standalone: false
})

export class CategoryMenuSectionComponent implements OnInit {
  public categories = [];
  public showSection = false;

  constructor(
    public router: Router,
    private blogService: BlogService,
    private trackingService: TrackingService,
  ) { }

  ngOnInit() {
    this.categories = [HOME_MENU];
    this.blogService.getCategories()
      .pipe(take(1))
      .subscribe((res: any) => {
        if (res && !res.error) {
          this.categories.push(...res);
          this.categories = this.categories.sort((p1: any, p2: any) => GhGlobal.compare(p1.position, p2.position, true));
        }
        this.displaySection();
      });
  }

  public navClick(label: string, location: string) {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'navigation',
      events: {
        click_text: label,
        feature: 'blog',
        environment: environment.env,
        location
      }
    });
  }

  public displaySection() {
    for (let index = 0; index < this.categories.length; index++) {
      if (this.categories[index].types?.includes("footer")) {
        this.showSection = true;
      }

      if (this.showSection) {
        break;
      }
    }
  }

}
